import { useCallback, useEffect, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";

import TableCM from "components/shared/Table";
import DrawerCM from "components/shared/Drawer";
import GenarateHeadCell from "helper/generate-head-cell";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import { getQuestionRequest } from "api/requests";

const headCells = GenarateHeadCell("common_question");

export default function Question() {
  const navigate = useNavigate();

  const [question, setQuestion] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();
  const [page, setPage] = useState(1);

  const getQuestion = useCallback(async () => {
    const res = await request({
      url: getQuestionRequest,
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      question: items.question,
      answer: items.answer,
    }));

    setQuestion({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getQuestion();
  }, [page, getQuestion]);

  return (
    <DrawerCM title="سوالات متداول">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container my={2} spacing={1}>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست سوالات"
                rows={question.data}
                headCells={headCells}
                addQuestion
                page={page}
                click={(questionId) => navigate("/question/edit/" + questionId)}
              />
            </Grid>
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
